import { gql } from 'apollo-boost';

export const CREATE_REWARD_CARD_PACK = gql`
    mutation createRewardCardPack($name: String!, $coverImageUrl: String, $designImageUrl: String, $previewImageUrl: String) {
        createRewardCardPack(name: $name, coverImageUrl: $coverImageUrl, designImageUrl: $designImageUrl, previewImageUrl: $previewImageUrl) {
            rewardCardPack {
                id
                coverImageUrl
                designImageUrl
                previewImageUrl
                name
                published
            }
        }
    }
`;

export const PUBLISH_REWARD_CARD_PACK = gql`
    mutation updateRewardCardPackPublishedStatus($rewardCardPackId: ID!, $published: Boolean!) {
        updateRewardCardPackPublishedStatus(rewardCardPackId: $rewardCardPackId, published: $published) {
            rewardCardPack {
                id
                coverImageUrl
                designImageUrl
                previewImageUrl
                name
                published
            }
        }
    }
`;

export const EDIT_REWARD_CARD_PACK = gql`
    mutation editRewardCardPack(
        $rewardCardPackId: ID!
        $name: String
        $coverImageUrl: String
        $designImageUrl: String
        $previewImageUrl: String
    ) {
        editRewardCardPack(
            rewardCardPackId: $rewardCardPackId
            name: $name
            coverImageUrl: $coverImageUrl
            designImageUrl: $designImageUrl
            previewImageUrl: $previewImageUrl
            ) {
            errors,
            rewardCardPack {
                id
                coverImageUrl
                designImageUrl
                previewImageUrl
                name
            }
        }
    }
`;